import de from './de';
import en from './en';
import es from './es';
import fr from './fr';

const translations = {
  de,
  en,
  es,
  fr
};

export default translations;
